import React from "react";

import Icon from "./Icon";
import FadeIn from "./FadeIn";

export default class OnboardingWelcome extends React.Component {
  render() {
    const { startPath } = this.props;

    return (
      <FadeIn>
        <div className="text-center joystix">
          <br />
          <br />
          <h1>Welcome to Clozemaster!</h1>
          <h4 style={{ marginBottom: 30, marginTop: 30 }}>Faster and more efficient language learning awaits you beyond this screen.</h4>
          <a className="btn btn-lg btn-success btn-block joystix" href={startPath}>Start <Icon name="chevron-right" /></a>
        </div>
      </FadeIn>
    );
  }
}
